import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';

// ✅ FUNCIÓN ESPECÍFICA PARA ERRORES DE ARCHIVO DEMASIADO GRANDE
const toastFileSizeError = (err) => {
	const errorMsg = err.response?.data?.error;
	const errorCode = err.response?.data?.code;
	
	// ✅ VERIFICAR SI ES ERROR DE ARCHIVO DEMASIADO GRANDE
	if (errorCode === 'FILE_TOO_LARGE' && errorMsg) {
		toast.error(errorMsg, {
			toastId: 'file-too-large-error',
			autoClose: false, // ✅ NO CERRAR AUTOMÁTICAMENTE
			hideProgressBar: true, // ✅ OCULTAR BARRA DE PROGRESO
			closeOnClick: false, // ✅ NO CERRAR AL HACER CLIC
			pauseOnHover: true, // ✅ PAUSAR AL HOVER
			draggable: true,
			progress: undefined,
			theme: "light",
			style: {
				backgroundColor: '#ff4444',
				color: '#ffffff',
				fontSize: '14px',
				fontWeight: 'bold',
				maxWidth: '400px',
				whiteSpace: 'pre-line' // ✅ PERMITIR SALTOS DE LÍNEA
			}
		});
		return true; // ✅ INDICAR QUE SE MANEJÓ EL ERROR
	}
	
	return false; // ✅ INDICAR QUE NO SE MANEJÓ
};

const toastError = err => {
	// ✅ MANEJAR ERRORES DE ARCHIVO DEMASIADO GRANDE PRIMERO
	if (toastFileSizeError(err)) {
		return;
	}
	
	const errorMsg = err.response?.data?.error;
	if (errorMsg) {
		if (i18n.exists(`backendErrors.${errorMsg}`)) {
			toast.error(i18n.t(`backendErrors.${errorMsg}`), {
				toastId: errorMsg,
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
				autoClose: 2000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				progress: undefined,
				theme: "light",
			});
			return
		}
	} if (isString(err)) {
		toast.error(err);
		return
	} else {
		toast.error("An error occurred!");
		return
	}
};

export default toastError;
